import makeStyles from '@mui/styles/makeStyles';
// @ts-ignore
import variables from 'styles/_variables.scss';

export const useStyles = makeStyles({
	pagination: {
		display: 'flex',
		listStyleType: 'none',
	},
	pageItem: {
		fontSize: '14px',
		lineHeight: '1.6',
		textTransform: 'uppercase',
		display: 'flex',
		alignItems: 'center',
		alignSelf: 'center',
		color: variables.newColorDisabled,
		borderRadius: '4px',
		padding: '4px 12px',
		margin: '0 4px',
		cursor: 'pointer',
		userSelect: 'none',

		'&.dots:hover': {
			cursor: 'default',
		},
		'&:hover:not(.dots)': {
			background: 'rgba(0, 0, 0, 0.04)',
		},
		'&.selected': {
			background: variables.buttonSecondaryHover,
		},

		'&.disabled': {
			pointerEvents: 'none',
			color: 'rgba(0, 0, 0, 0.26)',

			'&:hover': {
				background: 'transparent',
			},
		},
	},
	itemsPerPageSelect: {
		width: '80px',
		marginRight: '20px',

		'& .MuiSelect-select': {
			color: 'rgba(0, 0, 0, 0.54)',
		},
	},
});
